import { AwsConfig as AwsConstants } from '../Constants';

import BaseService, { RequestInterface } from '../Base';

import { NotificationEmail } from '@interfaces/global/notification/email';
import { NotificationPush } from '@interfaces/global/notification/push';
import { NotificationSMS } from '@interfaces/global/notification/sms';
import { Pillar } from '@interfaces/pillar';

export default class NotificationService extends BaseService {
    constructor(pillarWanted: Pillar | String) {
        console.log("service running with pillar: ", pillarWanted);
        switch (pillarWanted.toString()) {
            case 'AM':
                super(AwsConstants.API_AM, 'notification');
                console.log("constant: ", AwsConstants.API_AM);
                break;

            case 'QA':
                super(AwsConstants.API_QA, 'notification');
                console.log("constant: ", AwsConstants.API_QA);
                break;

            case 'QAFS':
                super(AwsConstants.API_QAFS, 'notification');
                console.log("constant: ", AwsConstants.API_QAFS);
                break;

            case 'EHSS':
                super(AwsConstants.API_EHSS, 'notification');
                console.log("constant: ", AwsConstants.API_EHSS);
                break;

            default:
                console.error("pillar not implemented yed: ", pillarWanted);
                break;
        }
        // console.log("constant: ", pillarWanted);

    }

    //EMAIL SECTION
    async getEmailById(id: string, fields?: string[]): Promise<NotificationEmail> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        const res = await super.get<NotificationEmail>(`email/${id}`, params);
        return res;
    }

    async updateEmailById(id: string, data: NotificationEmail): Promise<NotificationEmail> {
        const params: RequestInterface = {
            body: data
        };
        const res = await super.put<NotificationEmail>(`email/${id}`, params);
        return res;
    }

    async listAllEmail(fields?: string[]): Promise<NotificationEmail[]> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };

        const res = await super.get<NotificationEmail[]>('email', params);
        return res;
    }

    async createEmail(data: NotificationEmail): Promise<NotificationEmail> {
        const params: RequestInterface = {
            body: data
        };
        const res = await super.post<NotificationEmail>("email", params);
        return res;
    }
    async deleteEmailById(id: string): Promise<void> {
        await super.delete<void>(`email/${id}`);
    }

    //PUSH SECTION
    async getPushById(id: string, fields?: string[]): Promise<NotificationEmail> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        const res = await super.get<NotificationEmail>(`push/${id}`, params);
        return res;
    }

    async updatePushById(id: string, data: NotificationPush): Promise<NotificationPush> {
        const params: RequestInterface = {
            body: data
        };
        const res = await super.put<NotificationPush>(`push/${id}`, params);
        return res;
    }

    async listAllPush(fields?: string[]): Promise<NotificationPush[]> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };

        const res = await super.get<NotificationPush[]>('push', params);
        return res;
    }

    async createPush(data: NotificationPush): Promise<NotificationPush> {
        const params: RequestInterface = {
            body: data
        };
        const res = await super.post<NotificationPush>("push", params);
        return res;
    }

    async deletePushById(id: string): Promise<void> {
        await super.delete<void>(`push/${id}`);
    }

    //SMS SECTION
    async getSMSById(id: string, fields?: string[]): Promise<NotificationEmail> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        const res = await super.get<NotificationEmail>(`push/${id}`, params);
        return res;
    }

    async updateSMSById(id: string, data: NotificationSMS): Promise<NotificationSMS> {
        const params: RequestInterface = {
            body: data
        };
        const res = await super.put<NotificationSMS>(`sms/${id}`, params);
        return res;
    }

    async listAllSMS(fields?: string[]): Promise<NotificationSMS[]> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };

        const res = await super.get<NotificationSMS[]>('sms', params);
        return res;
    }

    async createSMS(data: NotificationSMS): Promise<NotificationSMS> {
        const params: RequestInterface = {
            body: data
        };
        const res = await super.post<NotificationSMS>("sms", params);
        return res;
    }

    async deleteSMSById(id: string): Promise<void> {
        await super.delete<void>(`sms/${id}`);
    }
}
